import { useEffect, useState } from 'react';
import LabelTwoToneIcon from '@mui/icons-material/LabelTwoTone';
import SellTwoToneIcon from '@mui/icons-material/SellTwoTone';
import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';

import { AppBar, Box, Button, Container, Dialog, IconButton, Stack, Toolbar, Typography, MenuItem, ListItemIcon, ListItemText } from "@mui/material"

import {
    Datagrid,
    DateField,
    FunctionField,
    Labeled,
    List,
    SelectInput,
    SimpleShowLayout,
    TextField,
    TextInput,
    useListContext,
    useNotify
} from "react-admin"
import { provinces } from '../utils';
import restProvider from '../../../rest.provider';
// import { PrintDialog } from '../components/PrintDialog';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { VBagLabel, VStudentLabel, VLabel, zBagLabel, zLabel, zStudentLabel } from './schoolDelivery/components';

export const ShippedStudentOrders = () => {
    const notify = useNotify()
    const [legacyPrinters, setLegacyPrinters] = useState({
        box: false,
        bag: false,
        student: false
    })
    const [printers, setPrinters] = useState({
        box: undefined,
        bag: undefined,
        student: undefined
    })
    const [apiPrinters, setApiPrinters] = useState({
        box: undefined,
        bag: undefined,
        student: undefined
    })

    const [studentLabels, setStudentLabels] = useState(() => {
        const settings = JSON.parse(localStorage.getItem('zWarehouse')) || {}
        return settings.studentLabels || 40
    })
    const [labels, setLabels] = useState(false)
    const [menuAnchorEl, setMenuAnchorEl] = useState(null)

    // Function to get printer selections from localStorage (same as Settings and Custom Labels)
    const getPrinterSelections = () => {
        try {
            const stored = localStorage.getItem('zWarehouse_printer_selections');
            const selections = stored ? JSON.parse(stored) : {};
            const defaultSelections = { box: null, bag: null, student: null };
            return { ...defaultSelections, ...selections };
        } catch (error) {
            console.error('Error loading printer selections:', error);
            return { box: null, bag: null, student: null };
        }
    };

    const Filters = [
        <TextInput source='batch' />,
        <TextInput source='city' />,
        <SelectInput
            source='province'
            optionText='province'
            optionValue='province'
            choices={provinces} />,
        <SelectInput
            source='delivery'
            choices={[
                { id: 'home', name: 'Home' },
                { id: 'school', name: 'School' }
            ]} />
    ]

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setMenuAnchorEl(null)
    }

    // Handle click outside to close menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if click is outside both the button and the dropdown
            const buttonElement = menuAnchorEl
            const dropdownElement = document.querySelector('[data-dropdown="print-labels"]')
            
            if (buttonElement && 
                !buttonElement.contains(event.target) && 
                !dropdownElement?.contains(event.target)) {
                handleMenuClose()
            }
        }

        if (Boolean(menuAnchorEl)) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [menuAnchorEl])

    const handleLegacyPrint = (labels, selectedIds, data) => {
        let printData = ''
        let selected = []
        selectedIds?.forEach(id => {
            selected = [...selected, data.find(item => item.id === id)]
        })

        switch (labels) {
            case 'box':
                selected.forEach(order => {
                    printData = printData + zLabel(order)
                })

                legacyPrinters?.box.send(printData)
                break

            case 'bag':
                selected.forEach(order => {
                    printData = printData + zBagLabel(order)
                })
                
                legacyPrinters?.bag.send(printData)
                break

            case 'student':
                selected.forEach(order => {
                    printData = Array.from(Array(+studentLabels).keys()).map(_ => {
                        return printData + '^XA' + zStudentLabel(order) + '^XZ'
                    })
                })

                try {
                    legacyPrinters.student.send(printData)
                } catch (e) {
                    console.error("Oops!", e)
                    notify('Unable to print!  Printer not responding', { type: 'error' })
                }

                break

            default:
                break                    
        }
    }

    const handleDirectPrint = async (labelType, contextData) => {
        handleMenuClose()
        
        // Use passed context data
        const { data, selectedIds } = contextData
        
        // Debug logging to understand the context data
        console.log('Direct Print Debug:', { 
            dataLength: data?.length, 
            selectedIdsLength: selectedIds?.length, 
            selectedIds, 
            data: data?.slice(0, 2) // First 2 items for debugging
        })
        
        // Get selected orders from context data
        const orders = data ? selectedIds.map(id => data.find(item => item.id === id)).filter(Boolean) : []
        
        console.log('Orders found:', orders.length, orders.slice(0, 2))
        
        if (orders.length === 0) {
            notify('No orders selected', { type: 'warning' })
            return
        }

        // Execute print logic directly
        let printData = ''

        switch (labelType) {
            case 'box':
                // Use API printer if available, otherwise fall back to legacy printer
                if (printers.box) {
                    try {
                        // Generate ZPL data for box labels
                        let zplData = ''
                        orders.forEach(order => {
                            zplData += zLabel(order)
                        })

                        // Send to printer API
                        const printResult = await restProvider.printLabel('printer', {
                            labelData: {
                                zpl: zplData
                            },
                            printer: printers.box.ip
                        })

                        if (printResult.data && printResult.data.success) {
                            const printerName = printers.box.name || printers.box.ip
                            const printerLocation = printers.box.location ? ` (${printers.box.location})` : ''
                            notify(`Box labels printed successfully to ${printerName}${printerLocation}`, { type: 'success' })
                        } else {
                            const errorMessage = printResult.data?.message || 'Failed to print box labels via API'
                            notify(errorMessage, { type: 'error' })
                        }
                    } catch (error) {
                        console.error('API print error:', error)
                        notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                        
                        // Fall back to legacy printer
                        try {
                            let legacyData = ''
                            orders.forEach(order => {
                                legacyData += zLabel(order)
                            })
                            printers.box.send(legacyData)
                            notify('Printed via legacy printer', { type: 'success' })
                        } catch (legacyError) {
                            console.error("Legacy printer error:", legacyError)
                            notify('Unable to print!  Both API and legacy printers failed', { type: 'error' })
                        }
                    }
                } else {
                    // Use legacy printer
                    try {
                        orders.forEach(order => {
                            printData += zLabel(order)
                        })
                        printers.box.send(printData)
                        notify('Printed via legacy printer', { type: 'success' })
                    } catch(e) {
                        console.error("Legacy printer error:", e)
                        notify('Unable to print!  Printer not responding', { type: 'error' })
                    }
                }
                break

            case 'bag':
                // Use API printer if available, otherwise fall back to legacy printer
                if (printers.bag) {
                    try {
                        // Generate ZPL data for bag labels
                        let zplData = ''
                        orders.forEach(order => {
                            zplData += zBagLabel(order)
                        })

                        // Send to printer API
                        const printResult = await restProvider.printLabel('printer', {
                            labelData: {
                                zpl: zplData
                            },
                            printer: printers.bag.ip
                        })

                        if (printResult.data && printResult.data.success) {
                            const printerName = printers.bag.name || printers.bag.ip
                            const printerLocation = printers.bag.location ? ` (${printers.bag.location})` : ''
                            notify(`Bag labels printed successfully to ${printerName}${printerLocation}`, { type: 'success' })
                        } else {
                            const errorMessage = printResult.data?.message || 'Failed to print bag labels via API'
                            notify(errorMessage, { type: 'error' })
                        }
                    } catch (error) {
                        console.error('API print error:', error)
                        notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                        
                        // Fall back to legacy printer
                        try {
                            let legacyData = ''
                            orders.forEach(order => {
                                legacyData += zBagLabel(order)
                            })
                            printers.bag.send(legacyData)
                            notify('Printed via legacy printer', { type: 'success' })
                        } catch (legacyError) {
                            console.error("Legacy printer error:", legacyError)
                            notify('Unable to print!  Both API and legacy printers failed', { type: 'error' })
                        }
                    }
                } else {
                    // Use legacy printer
                    try {
                        orders.forEach(order => {
                            printData += zBagLabel(order)
                        })
                        printers.bag.send(printData)
                        notify('Printed via legacy printer', { type: 'success' })
                    } catch(e) {
                        console.error("Legacy printer error:", e)
                        notify('Unable to print!  Printer not responding', { type: 'error' })
                    }
                }
                break

            case 'student':
                // Get current printer selections from localStorage
                const printerSelections = getPrinterSelections();
                const studentPrinter = printerSelections.student;
                
                // Use API printer if available, otherwise fall back to legacy printer
                if (studentPrinter && studentPrinter.ip) {
                    try {
                        // Print each order's student labels using the student_labels format
                        for (const order of orders) {
                            const studentName = order.student || 'Student'
                            
                            // Send to printer API using student_labels format
                            const printResult = await restProvider.printLabel('printer', {
                                labelType: 'student_labels',
                                labelData: {
                                    studentName: studentName,
                                    numLabels: +studentLabels,
                                    defaultFontSize: 56,
                                    abbreviateLongNames: true
                                },
                                printer: studentPrinter.ip
                            })

                            if (!printResult.data || !printResult.data.success) {
                                const errorMessage = printResult.data?.message || 'Failed to print student labels via API'
                                notify(errorMessage, { type: 'error' })
                                break // Stop printing if one fails
                            }
                        }

                        const printerName = studentPrinter.name || studentPrinter.ip
                        const printerLocation = studentPrinter.location ? ` (${studentPrinter.location})` : ''
                        notify(`Student labels printed successfully to ${printerName}${printerLocation}`, { type: 'success' })
                    } catch (error) {
                        console.error('API print error:', error)
                        notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                        
                        // Fall back to legacy printer
                        try {
                            let legacyData = ''
                            orders.forEach(order => {
                                for (let i = 0; i < +studentLabels; i++) {
                                    legacyData += '^XA' + zStudentLabel(order) + '^XZ'
                                }
                            })
                            printers.student.send(legacyData)
                            notify('Student labels printed via legacy printer', { type: 'success' })
                        } catch (legacyError) {
                            console.error("Legacy printer error:", legacyError)
                            notify('Unable to print!  Both API and legacy printers failed', { type: 'error' })
                        }
                    }
                } else {
                    // Use legacy printer
                    try {
                        orders.forEach(order => {
                            for (let i = 0; i < +studentLabels; i++) {
                                printData += '^XA' + zStudentLabel(order) + '^XZ'
                            }
                        })
                        printers?.student.send(printData)
                        notify('Student labels printed via legacy printer', { type: 'success' })
                    } catch(e) {
                        console.error("Legacy printer error:", e)
                        notify('Unable to print!  Printer not responding', { type: 'error'})
                    }
                }
                break

            default:
                break
        }
    }

    const Actions = () => {
        // Get context data inside the Actions component
        const { data, selectedIds } = useListContext()
        
        return (
            <>
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                        variant='outlined'
                        onClick={handleMenuOpen}
                        endIcon={<MoreVertIcon />}
                    >
                        Print Labels
                    </Button>
                    {Boolean(menuAnchorEl) && (
                    <Box
                        data-dropdown="print-labels"
                        sx={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            zIndex: 1300,
                            bgcolor: 'background.paper',
                            border: 1,
                            borderColor: 'divider',
                            borderRadius: 1,
                            boxShadow: 3,
                            minWidth: 200,
                            display: 'block',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <MenuItem onClick={() => handleLegacyPrint('box', selectedIds, data)}>
                            <ListItemIcon>
                                <PrintIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Print Box Labels</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => handleLegacyPrint('bag', selectedIds, data)}>
                            <ListItemIcon>
                                <PrintIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Print Bag Labels</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => handleDirectPrint('student', { data, selectedIds })}>
                            <ListItemIcon>
                                <PrintIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Print Student Labels</ListItemText>
                        </MenuItem>
                    </Box>
                )}
                </Box>
            </>
        )
    }

    const Preview = () => {
        const { data, selectedIds } = useListContext()
        const [orders, setOrders] = useState([])

        const handlePrint = async () => {
            let data = ''

            switch (labels) {
                case 'box':
                    // Use API printer if available, otherwise fall back to legacy printer
                    if (apiPrinters.box) {
                        try {
                            // Generate ZPL data for box labels
                            let zplData = ''
                            orders.forEach(order => {
                                zplData += zLabel(order)
                            })

                            // Send to printer API
                            const printResult = await restProvider.printLabel('printer', {
                                labelData: {
                                    zpl: zplData
                                },
                                printer: apiPrinters.box.ip
                            })

                            if (printResult.data && printResult.data.success) {
                                notify(`Box labels printed successfully to ${apiPrinters.box.name || apiPrinters.box.ip}`, { type: 'success' })
                            } else {
                                const errorMessage = printResult.data?.message || 'Failed to print box labels via API'
                                notify(errorMessage, { type: 'error' })
                            }
                        } catch (error) {
                            console.error('API print error:', error)
                            notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                            
                            // Fall back to legacy printer
                            try {
                                let legacyData = ''
                                orders.forEach(order => {
                                    legacyData += zLabel(order)
                                })
                                printers.box.send(legacyData)
                                notify('Printed via legacy printer', { type: 'success' })
                            } catch (legacyError) {
                                console.error("Legacy printer error:", legacyError)
                                notify('Unable to print!  Both API and legacy printers failed', { type: 'error' })
                            }
                        }
                    } else {
                        // Use legacy printer
                        try {
                            orders.forEach(order => {
                                data += zLabel(order)
                            })
                            printers.box.send(data)
                            notify('Printed via legacy printer', { type: 'success' })
                        } catch(e) {
                            console.error("Legacy printer error:", e)
                            notify('Unable to print!  Printer not responding', { type: 'error' })
                        }
                    }
                    break

                case 'bag':
                    // Use API printer if available, otherwise fall back to legacy printer
                    if (apiPrinters.bag) {
                        try {
                            // Generate ZPL data for bag labels
                            let zplData = ''
                            orders.forEach(order => {
                                zplData += zBagLabel(order)
                            })

                            // Send to printer API
                            const printResult = await restProvider.printLabel('printer', {
                                labelData: {
                                    zpl: zplData
                                },
                                printer: apiPrinters.bag.ip
                            })

                            if (printResult.data && printResult.data.success) {
                                notify(`Bag labels printed successfully to ${apiPrinters.bag.name || apiPrinters.bag.ip}`, { type: 'success' })
                            } else {
                                const errorMessage = printResult.data?.message || 'Failed to print bag labels via API'
                                notify(errorMessage, { type: 'error' })
                            }
                        } catch (error) {
                            console.error('API print error:', error)
                            notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                            
                            // Fall back to legacy printer
                            try {
                                let legacyData = ''
                                orders.forEach(order => {
                                    legacyData += zBagLabel(order)
                                })
                                printers.bag.send(legacyData)
                                notify('Printed via legacy printer', { type: 'success' })
                            } catch (legacyError) {
                                console.error("Legacy printer error:", legacyError)
                                notify('Unable to print via API, falling back to legacy printer', { type: 'warning' })
                            }
                        }
                    } else {
                        // Use legacy printer
                        try {
                            orders.forEach(order => {
                                data += zBagLabel(order)
                            })
                            printers.bag.send(data)
                            notify('Printed via legacy printer', { type: 'success' })
                        } catch(e) {
                            console.error("Legacy printer error:", e)
                            notify('Unable to print!  Printer not responding', { type: 'error' })
                        }
                    }
                    break

                case 'student':
                    // Use API printer if available, otherwise fall back to legacy printer
                    if (apiPrinters.student) {
                        try {
                            // Print each order's student labels using the student_labels format
                            for (const order of orders) {
                                const studentName = order.student || 'Student'
                                
                                // Send to printer API using student_labels format
                                const printResult = await restProvider.printLabel('printer', {
                                    labelType: 'student_labels',
                                    labelData: {
                                        studentName: studentName,
                                        numLabels: +studentLabels,
                                        defaultFontSize: 56,
                                        abbreviateLongNames: true
                                    },
                                    printer: apiPrinters.student.ip
                                })

                                if (!printResult.data || !printResult.data.success) {
                                    const errorMessage = printResult.data?.message || 'Failed to print student labels via API'
                                    notify(errorMessage, { type: 'error' })
                                    break // Stop printing if one fails
                                }
                            }

                            notify(`Student labels printed successfully to ${apiPrinters.student.name || apiPrinters.student.ip}`, { type: 'success' })
                        } catch (error) {
                            console.error('API print error:', error)
                            notify('Failed to print via API, falling back to legacy printer', { type: 'warning' })
                            
                            // Fall back to legacy printer
                            try {
                                let legacyData = ''
                                orders.forEach(order => {
                                    for (let i = 0; i < +studentLabels; i++) {
                                        legacyData += '^XA' + zStudentLabel(order) + '^XZ'
                                    }
                                })
                                printers.student.send(legacyData)
                                notify('Printed via legacy printer', { type: 'success' })
                            } catch (legacyError) {
                                console.error("Legacy printer error:", legacyError)
                                notify('Unable to print!  Both API and legacy printers failed', { type: 'error' })
                            }
                        }
                    } else {
                        // Use legacy printer
                        try {
                            orders.forEach(order => {
                                for (let i = 0; i < +studentLabels; i++) {
                                    data += '^XA' + zStudentLabel(order) + '^XZ'
                                }
                            })
                            printers.student.send(data)
                            notify('Printed via legacy printer', { type: 'success' })
                        } catch(e) {
                            console.error("Legacy printer error:", e)
                            notify('Unable to print!  Printer not responding', { type: 'error' })
                        }
                    }
                    break                    

                default:
                    break
            }
        }

        useEffect(() => {
            let selected = []
            if (data) {
                selectedIds.forEach(id => {
                    selected = [...selected, data.find(item => item.id === id)]
                })
                setOrders(selected)
            }

        }, [data, selectedIds])

        return (
            <Dialog open={labels ? true : false} onClose={() => setLabels()} fullWidth>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Typography sx={{ ml: 2, flex: 1 }} variant='h5' component='div'>
                            {labels === 'box' && 'Box Labels (preview)'}
                            {labels === 'bag' && 'Bag Labels (preview)'}
                            {labels === 'student' && `Student Labels (x${studentLabels})`}
                        </Typography>

                        <Stack direction='row' spacing={1}>
                            <IconButton
                                color='inherit'
                                onClick={handlePrint}>
                                <PrintIcon fontSize='large' />
                            </IconButton>

                            <IconButton
                                color='inherit'
                                onClick={() => setLabels()}
                                aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Stack>

                    </Toolbar>
                </AppBar>

                <Box>
                    {labels === 'box' && orders && orders.map((order, idx) =>
                        <VLabel order={order} key={idx} />
                    )}
                    {labels === 'bag' && orders && orders.map((order, idx) =>
                        <VBagLabel order={order} key={idx} />
                    )}
                    {labels === 'student' && orders && orders.map((order, idx) =>
                        <VStudentLabel order={order} key={idx} />
                    )}
                </Box>
            </Dialog>
        )
    }

    const Expanded = () => (
        <SimpleShowLayout>
            <Stack direction='row' spacing={2}>
                <Labeled label='Kit / Grade'>
                    <TextField source='kit.name' />
                </Labeled>

                <Labeled label='School'>
                    <TextField source='school' />
                </Labeled>

                <Labeled label='Box #'>
                    <TextField source='box' />
                </Labeled>

                <Labeled label='Purolator Pin'>
                    <TextField source='purolatorId' />
                </Labeled>
            </Stack>
        </SimpleShowLayout>
    )
    
    useEffect(() => {
        const settings = JSON.parse(localStorage.getItem('zWarehouse'))
        const { printers, studentLabels, apiPrinters } = settings
        const { printer } = window.devices

        if (printer) {
            setLegacyPrinters({
                box: printer.find(p => p.uid === printers['box']?.uid),
                bag: printer.find(p => p.uid === printers['bag']?.uid),
                student: printer.find(p => p.uid === printers['student']?.uid)
            })
        }

        if (apiPrinters) {
            setApiPrinters(apiPrinters)
        }

        if (studentLabels) {
            setStudentLabels(studentLabels)
        }
    }, [])

    return (
        <Container>
            <Stack direction='row' spacing={2} mt={2}>
                <RocketLaunchTwoToneIcon sx={{ fontSize: 46 }} color="primary" />
                <Typography variant='h4' color='primary'>
                    Shipped Student Orders
                </Typography>
            </Stack>

            <List
                title='Shipped Student Orders'
                resource="ShippedStudentOrder"
                filters={Filters}>
                <>
                    <Preview />

                    <Datagrid bulkActionButtons={<Actions />} expand={<Expanded />}>
                        <TextField source='batch' />
                        <FunctionField label='Order #' render={item => 
                            `${item.is_store_products ? 'A' : 'K'}-#${item.orderId}-${item.id}`
                        }/>
                        <TextField source='order.delivery' label='Delivery' />
                        <DateField source='set_to_shipped' label='Shipped' />
                        <TextField source='student' label='Student' />
                        
                        <FunctionField label='City/Province' render={item =>
                            (item.delivery) === 'home'
                                ? `${item.customer.adress.city}, ${item.customer.address.province}`
                                : `${item.city}, ${item.school_address.province}`
                        }/>
                    </Datagrid>
                </>
            </List>

        </Container>
    )
}